<template>
    <div class="container-fluid bg-white courses-grid">
        <a :href="getUrlCourse(course)" class="row mx-0 mb-3 tile-item" v-for="course in courses" :key="course" :class="{ 'tile-application': isApplication(course) }">            <div class="col-12 col-sm-6 col-md-auto px-0">
                <div v-if="showStartDate(course) && !course.isApplication" class="tile-calendar">
                    <div class="tile-month">{{ mergeDateTime(course.course_start_date, course.course_start_hour) | formatShortMonth(timezoneHelper(course)) }}</div>
                    <div class="tile-day">{{ mergeDateTime(course.course_start_date, course.course_start_hour) | formatDay(timezoneHelper(course)) }}</div>
                    <div class="tile-hour" :class="{ invisible: !(course.course_start_hour && course.course_start_hour!='00:00:00') }">{{ mergeDateTime(course.course_start_date, course.course_start_hour) | formatTime(timezoneHelper(course)) }}</div>
                </div>
                <img v-if="!!course.course_image" loading="lazy" :src="'index.php?r=course/getFile&courseid='+course.id+'&file='+course.course_image" :alt="course.name" class="img-fluid" @error="course.course_image = null;" />
                <canvas v-else class="canvas-image img-fluid" v-bind:style="getGradient()" ></canvas>
            </div>
            <div class="col-12 col-sm-6 col-md pr-md-0 align-self-center">
                <p class="tile-title">{{ course.name }}</p>
                <p v-if="course.isApplication && showStartDate(course)" class="tile-available"><span>{{ t('Available:') }}&nbsp;{{ course.course_start_date | formatAppDate(timezoneHelper(course)) }}</span><span v-if="showEndDate(course)">&nbsp;{{ t('to') }}&nbsp;{{ course.course_end_date | formatAppDate(timezoneHelper(course)) }}</span></p>
                <p v-else-if="!course.isApplication && hasLocation(course)" class="tile-location"><OnlineIcon v-if="course.course_type === 'online'" :isDarker="true" /><OnsiteIcon v-else-if="course.course_type === 'onsite'" :isDarker="true" /><span :title="course.formattedAddress">{{ course.formattedAddress }}</span></p>
                <p class="tile-type">{{ course.isApplication ? t('Application') : t('EVENT') }}</p>
            </div>
            <div class="col-12 col-md-3 px-3 align-self-center pb-3 pb-md-0">
                <div class="d-flex flex-column">
                    <div class="flags-container"><CourseFlags v-if="!course.isApplication" :course="course" :forList="true" /></div>
                    <div class="tile-price">
                        <span v-if="course.isApplication"></span>
                        <span v-else class="text-right" :title="freeSeats(course.price, course.highest_price) ? t('FREE') : getRangeOfPrices(course.price, course.highest_price)">{{ freeSeats(course.price, course.highest_price) ? t('FREE') : getRangeOfPrices(course.price, course.highest_price) }}</span>
                        <HeartReactionIcon :isWhite="course.isApplication" :course="course" :isSmall="true" />
                    </div>
                </div>
            </div>
        </a>
    </div>
    <!--table class="table">
        <thead>
            <tr>
                <th>{{t('Event')}}</th>
                <th class="text-center">{{t('Start & End Dates')}}</th>
                <th class="text-center">{{t('Available')}}</th>
                <th class="text-center">{{t('Price')}}</th>
                <th class="text-center">{{t('Save')}}</th>
                <th class="text-center">{{t('Enroll')}}</th>
            </tr>
        </thead>

        <tbody>
            <tr v-for="course in courses">
            <td class="title pl-0" style="padding-top: 7px; padding-bottom: 7px;">
                <div class="img-wrapper mr-2">
                    <img :src="course.image" alt="Event image">
                </div>
                <div class="data-section float-left pt-3">
                    <template  v-if="course.course_type === 'online'">
                        <online-icon></online-icon>
                        <span class="online-label">{{t('Online Event')}}</span> <br>
                    </template>
                    <template  v-if="course.course_type === 'onsite'">
                        <onsite-icon></onsite-icon>
                        <span class="address-label">{{location(course)}}</span><br>
                    </template>
                    <div class="d-inline-block">
                        <a :href="course.url"
                           style="display: block; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;
                                overflow: hidden; text-overflow: ellipsis;">
                            {{course.name}}
                        </a>
                    </div>
                </div>
            </td>

            <td class="text-left course-column">
                <template v-if="isValidDate(course.course_start_date)">
                    {{course.course_start_date | formatDate}}
                </template>
                <template v-if="isValidDate(course.course_end_date)">
                    {{t('to')}}<br>
                    {{course.course_end_date | formatDate}}
                </template>
            </td>

            <td class="text-center course-column">
                <div v-if="!course.price || course.price === 'FREE'"
                     class="text">
                    <free-course-flag></free-course-flag>
                </div>
                <div class="text"
                     v-else-if="course.space === course.available">
                    <new-course-flag></new-course-flag>
                </div>

                <div class="text white"
                     v-else-if="course.space > course.available && course.available <= 3 && course.available !== 0">
                    <available-courses-flag :count="course.available">
                    </available-courses-flag>
                </div>

                <div class="text"
                     v-else-if="course.available === 0">
                    <full-course-flag></full-course-flag>
                </div>

                <div class="text"
                     v-else-if="course.space > course.available && course.available > 3 && course.available !== 0">
                    <i class="new-bg-ok-green">
                        <span class="available">{{course.available}}/{{course.space}}</span>
                    </i>
                </div>
            </td>

            <td class="text-center course-column">
                <template v-if="course.price">
                    {{course.price}}
                </template>
                <template v-else>
                    {{t('FREE')}}
                </template>
            </td>

            <td class="text-center course-column">
                <HeartReactionIcon :course="course" :isSmall="true" />
            </td>

            <td class="text-center course-column">
                <b-button type="button"
                          v-if="showEnrollFunc(course)"
                          @click="$emit('enroll', course.id)"
                          :style="corporationStyles"
                          class="btn btn-light enroll">
                    {{t('Enroll')}}
                    <i class="bg-add-participant mr-1 pull-right mt-1"></i>
                </b-button>

                <b-button type="button"
                          v-else-if="showWaitListFunc(course)"
                          :style="corporationStyles"
                          @click="$emit('wait-list', course.id)"
                          class="btn btn-light enroll">
                    {{t('Waitlist')}}

                    <wait-list-icon class="pull-right mt-1"></wait-list-icon>
                </b-button>

                <b-button type="button"
                          v-else-if="showWaitingFunc(course)"
                          disabled
                          :style="corporationStyles"
                          @click="$emit('wait-list-out', course.id)"
                          class="btn btn-light enroll">
                   {{t('Waiting')}}
                    <wait-list-icon class="pull-right mt-1"></wait-list-icon>
                </b-button>

                <b-button v-else-if="showSoldOutFunc(course)"
                          type="button" class="btn btn-light full-btn">

                    {{t('Full Event')}}
                    <svg width="20" height="10" xmlns="http://www.w3.org/2000/svg">
                    	<g id="Course-Templates" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" class="pull-right mt-1">
                    	<g id="Marketplace-GRID-simple" transform="translate(-104 -1918)" fill="#ABABAB"><g id="full2" transform="translate(104 1918)">
                    	<path d="M18.154 0v2.42H20v4.838h-1.846v2.42H0V0h18.154zm-.923.907H.923V8.77h16.308V.907zM2.119 1.935l6.268 5.807H1.935V1.935h.184zm7.394 0l5.65 5.807h-5.65L3.245 1.935h6.268zm6.496 0l-.001 5.685-5.685-5.685h5.686zm3.068 1.392h-.923V6.35h.923V3.327z" id="Combined-Shape"/>
                    	</g></g></g>
                    </svg>
                    <i class="fa fa-frown-o pull-right mt-1" aria-hidden="true"></i>
                </b-button>

                <b-button v-else-if="showProgram"
                          type="button" class="btn btn-light program">
                    {{t('View Program')}}
                    <i class="bg-add-participant mr-1 mt-1 pull-right"></i>
                </b-button>
            </td>
        </tr>
        </tbody>
    </table-->
</template>

<script>
import API from '@/api/index';
import CourseFlags from '@/components/CourseFlags';
import OnlineIcon from '@/components/Icons/OnlineCourse';
import OnsiteIcon from '@/components/Icons/OnsiteCourse';
import EnrollBtnUtils from '@/mixins/EnrollBtnUtils';
import HeartReactionIcon from '@/components/Icons/HeartReactionIcon';
import ApplicationMixin from '@/mixins/ApplicationMixin';
import FormattingMixin from '@/mixins/FormattingMixin';

export default {
    name: "CoursesGrid",
    mixins: [
        EnrollBtnUtils,
        ApplicationMixin,
        FormattingMixin,
    ],
    props: {
        courses: {
            type: Array
        }
    },
    data() {
        return {
            showLoader: false,
            isSafari: /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
        }
    },
    components: {
        //WaitListIcon,
        OnlineIcon,
        OnsiteIcon,
        HeartReactionIcon,
        CourseFlags,
    },
    filters: {
        formatDate(dateItem) {
            return moment(dateItem, 'YYYY-MM-DD').format('MMM D, YYYY');
        }
    },
    computed: {
        corporationStyles() {
            let styles = {};
            const courseListColor = _.get(this.$parent, 'corporation.color_enroll_course_list', null);

            if (courseListColor) {
                styles.backgroundColor = courseListColor;
                styles.borderColor = courseListColor;
            }

            return styles;
        },
    },
    methods: {
        location(course) {
            let fullAddress = '';

            if (_.get(course, 'locations[0].address', false)) {
                fullAddress += _.get(course, 'locations[0].address', '') + ', ';
            }

            if (_.get(course, 'locations[0].city', false)) {
                fullAddress += _.get(course, 'locations[0].city', '') + ', ';
            }

            if (_.get(course, 'locations[0].country', false)) {
                fullAddress += _.get(course, 'locations[0].country', '');
            }

            return fullAddress;
        },
        isValidDate(dateValue) {
            return moment(dateValue, 'YYYY-MM-DD').isValid();
        },
        changeReaction(course) {
            course.has_like = !course.has_like;
            API.main.saveReaction({
                id_course: course.id,
                has_like: course.has_like
            });
        },
        getRandomColor() {
            // if randomColor cndjs is not available
            let letters = "0123456789ABCDEF";
            let color = "#";
            for (let i = 0; i < 6; i++) {
                color += letters[Math.floor(Math.random() * 16777216)];
            }
            return color;
        },
        getGradient() {
            if (randomColor()) {
                let a = randomColor();
                let b = randomColor();
                return { background: "linear-gradient(to right," + a + ", " + b + ")" };
            } else {
                let a = this.getRandomColor();
                let b = this.getRandomColor();
                return { background: "linear-gradient(to right," + a + ", " + b + ")" };
            }
        },
        isApplication(course) {
            const isApplication = course.id_course_behavior === 1;
            this.$set(course, 'isApplication', isApplication);
            return isApplication;
        },
        removeCurrency(price){
            if(price){
                // let example = "$11.66 CAD"
                // console.log('Current price', price);
                if(typeof price === "string"){
                    let array = price.split(" ");
                    return array[0];
                }else{
                    return `$${price.toString()}`; //"$11.66"
                }
            }else{
                return ""
            }
        },
        getRangeOfPrices(price, highest_price){
            price = price === 'FREE' || price === 0 ? price = this.t('FREE') : this.removeCurrency(price);
            highest_price = this.removeCurrency(highest_price);

            // console.log('Prices', price, highest_price);
            if(price === highest_price){
                return price
            }else{
                return `${price} - ${highest_price}`
            }
        },
        freeSeats(price, highest_price){
            price = price === 'FREE' || price === 0 ? price = 0 : price;
            highest_price = highest_price === 'FREE' || highest_price === 0 || highest_price === null ? highest_price = 0 : highest_price;

            if(price === highest_price){
                return true
            }else{
                return false
            }
        },
        hasLocation(course) {
            let formattedAddress = '';
            course.locations.forEach(location=> formattedAddress+=[location.loc_address, location.loc_zip_code, location.loc_state, location.loc_city, location.country].filter(ld=>!!ld).join(', '));
            this.$set(course, 'formattedAddress', formattedAddress);
            return !!formattedAddress;
        },
        getUrlCourse(course){
        	return (CATALOGUE_PATH ? CATALOGUE_PATH + course.id  : course.url) + (Object.keys(this.$route.params).length > 0 ? '#' + this.$route.path : '');
        },
        showStartDate(course) {
            return moment(course.course_start_date, 'YYYY-MM-DD').isValid();
        },
        showEndDate(course) {
            return moment(course.course_end_date, 'YYYY-MM-DD').isValid();
        },
    }
}
</script>

<style scoped>
    /**td.course-column {
        line-height: 22px;
        padding-top: 25px;

        font-family: "Source Sans Pro";
        font-size: 16px;
        color: #383838;
    }

    .img-wrapper {
        width: 161px;
        height: 67px;
        overflow: hidden;
        background-color: #f6f6f6;
        float: left;
    }

    .title a {
        color: #256AB3;
        font-family: "Source Sans Pro";
        font-size: 16px;
        line-height: 22px;
    }

    .course-column button.enroll:active,
    .course-column button.enroll {
        background-color: #00AEEF;
        border-color: #00aeef;
        color: white;
        width: 148px;
        text-align: left;
        padding-top: 0;
    }

    .course-column button.program:active,
    .course-column button.program {
        background-color: #F4981F;
        border-color: #F4981F;
        color: white;
        width: 148px;
        text-align: left;

        height: 28px;
        padding-top: 0;
    }

    .course-column button.full-btn:active,
    .course-column button.full-btn {
        background-color: transparent;
        border-color: #F4981F;
        color: #383838;
        width: 148px;
        text-align: left;

        height: 28px;
        padding-top: 0;
    }

    span.address-label,
    span.online-label {
        font-family: "Source Sans Pro";
        font-size: 12px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.33;
        letter-spacing: normal;
        color: #ababab;
        text-transform: uppercase;
    }

    .text span.available {
        font-family: "Source Sans Pro";
        color: #383838;
        top: 2px;
        position: absolute;
        right: 12px;
    }

    .data-section {
        width: calc(100% - 180px);
        -webkit-line-clamp: 2;
        overflow : hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;

        max-width: 300px;
    }**/
     
    .tile-item-safari {
        aspect-ratio: 200/88;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        height: 88px;
        -o-object-fit: cover;
        object-fit: cover;
        width: 300px;
    }
    .tile-item {
        border: 1px solid rgb(227,229,232);
        border-radius: 4px;
    }
     /* Atributo para Safari */
    @media screen and (-webkit-min-device-pixel-ratio:0) {
        .tile-item[data-v-34340304] .img-fluid {
            aspect-ratio: 200/88;
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
            height: 88px;
            -o-object-fit: cover;
            object-fit: cover;
            width: 300px;
        }
    }
    .tile-application {
        background-color: rgb(234,96,47);
    }
    .tile-item:hover {
        cursor: pointer;
        -webkit-box-shadow: 0px 2px 6px 0px rgba(159, 165, 172, 0.5);
        box-shadow: 0px 2px 6px 0px rgba(159, 165, 172, 0.5);
        text-decoration: none;
    }
    .tile-item /deep/ .img-fluid {
        aspect-ratio: 200/88;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        height: 88px;
        object-fit: cover;
        width: 100%;
    }
    .tile-item:hover /deep/ .img-fluid {
        opacity: 0.7;
    }
    .tile-item /deep/ .tile-title {
        color: rgb(56,56,56);
        font-size: 1.125rem;
        font-weight: bolder;
        line-height: 1.375rem;
        margin-bottom: 4px;
    }
    .tile-item /deep/ .tile-type {
        color: rgb(56,56,56);
        font-size: 0.75rem;
        font-weight: bolder;
        line-height: 1.25rem;
        margin-bottom: 0;
        text-transform: uppercase;
    }
    .tile-item /deep/ .tile-price {
        align-items: center;
        display: grid;
        grid-template-columns: 1fr 20px;
        gap: 15px;
    }
    .tile-item /deep/ .tile-price > span {
        color: rgb(56,56,56);
        font-size: 1.125rem;
        line-height: 1.625rem;
        text-transform: uppercase;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    .tile-item /deep/ .tile-location {
        align-items: center;
        display: grid;
        gap: 8px;
        grid-template-columns: 18px 1fr;
        margin-bottom: 0;
    }
    .tile-item /deep/ .tile-location span,
    .tile-application /deep/ .tile-available span {
        color: rgb(56,56,56);
        font-size: 0.875rem;
        line-height: 1.25rem;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    .tile-item /deep/ .tile-calendar {
        background-color: rgb(255,255,255);
        border-top-left-radius: 4px;
        border-bottom-right-radius: 4px;
        position: absolute;
        width: 2.875rem;
        z-index: 1;
    }
    .tile-item:hover /deep/ .tile-calendar {
        opacity: 0.7;
    }
    .tile-item /deep/ .tile-calendar .tile-month {
        background-color: rgb(217,90,75);
        border-top-left-radius: 4px;
        color: rgb(255,255,255);
        font-size: 0.75rem;
        line-height: 1rem;
        text-transform: uppercase;
        text-align: center;
    }
    .tile-item /deep/ .tile-calendar .tile-day {
        color: rgb(56,56,56);
        font-size: 1.375rem;
        line-height: 1.625rem;
        text-align: center;
    }
    .tile-item /deep/ .tile-calendar .tile-hour {
        color: rgb(56,56,56);
        font-size: 0.75rem;
        line-height: 1rem;
        text-align: center;
    }
    .d-flex.flex-column {
        gap: 5px;
    }
    .flags-container {
        height: 34px;
    }
    .tile-application /deep/ .tile-available {
        margin-bottom: 0;
    }
    .tile-application /deep/ .tile-title,
    .tile-application /deep/ .tile-type,
    .tile-application /deep/ .tile-available span {
        color: rgb(255,255,255);
    }
    .courses-grid /deep/ .course-flags {
        font-family: "Source Sans Pro";
        font-size: 12px;
        font-weight: 600;
        top: 0;
        right: -8px;
    }
    @media (min-width: 576px) {
        .tile-item /deep/ .img-fluid {
            border-top-right-radius: 0;
        }
    }
    @media (min-width: 768px) {
        .tile-item /deep/ .img-fluid {
            border-bottom-left-radius: 4px;
        }
    }
</style>